import PresentationTypeList from './PresentationTypeList';

export default PresentationTypeList;
